import { useTranslation } from 'react-i18next';

import { Button, Text } from '@pukka/ui-components';

import { IBrandsFormState } from '../BrandsForm';

function ParentBrandName({
  id,
  name,
  totalBrands,
  onClickAddBrand,
  onClickEdit,
}: {
  id: number;
  name: string;
  totalBrands: number;
  onClickAddBrand: (id: number, name: string) => void;
  onClickEdit: IBrandsFormState['handleClickEditParent'];
}) {
  const { t } = useTranslation('library');

  const handleClickAddBrand = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClickAddBrand(id, name);
  };

  const handleClickEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClickEdit(id, name);
  };

  const isRealParent = id !== -1;

  return (
    <div className="group flex min-w-0 flex-1 items-center gap-1 px-4">
      <div>
        <Text className="truncate text-neutral-900">{name}</Text>
        {isRealParent && totalBrands > 0 && (
          <Text variant="body-1" className="text-neutral-400">
            {t('brands.brands', { count: totalBrands })}
          </Text>
        )}
      </div>

      {isRealParent && (
        <>
          <Button
            variant="nude-blue"
            size="s"
            icon="plus"
            className="hidden border-none bg-transparent group-hover:block"
            onClick={handleClickAddBrand}
          >
            <span className="max-w-72 truncate">Add brand under {name}</span>
          </Button>
          <Button
            variant="nude-blue"
            size="s"
            icon="edit"
            className="hidden border-none bg-transparent group-hover:block"
            onClick={handleClickEdit}
          >
            {t('brands.editParent')}
          </Button>
        </>
      )}
    </div>
  );
}

export { ParentBrandName };
